<div id="schedule" *ngIf="payload && payload != '[]'; else empty">
  <div *ngFor="let day of DaysOfWeek" class="day-events">
    <div *ngIf="!!daySchedule(day)">
      <span class="day">{{day}}</span>
      <span class="schedule">{{daySchedule(day)}}</span>
    </div>
  </div>
</div>
<ng-template #empty>No events in schedule</ng-template>
